/**
 * GeChiUI dependencies
 */
import { createSlotFill } from '@gechiui/components';

const { Slot: ViewerSlot, Fill: ViewerFill } = createSlotFill(
	'BlockEditorLinkControlViewer'
);

export { ViewerSlot, ViewerFill };
export default ViewerSlot;
